/* eslint-disable no-restricted-imports */
import {
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialog as ChakraAlertDialog,
} from '@chakra-ui/react';
import React, { useRef } from 'react';
import { Button } from '../Button';

export type InfoAlertProps = {
  isOpen: boolean;
  onClose: () => void;
  headerText: string;
  bodyText: string;
};

export const InfoAlert: React.FC<InfoAlertProps> = ({
  isOpen,
  onClose,
  headerText,
  bodyText,
}) => {
  const cancelRef = useRef<HTMLButtonElement>(null);

  return (
    <ChakraAlertDialog
      leastDestructiveRef={cancelRef}
      isOpen={isOpen}
      isCentered
      onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent bg="surface.panel">
          <AlertDialogHeader
            fontSize="md"
            fontWeight="medium"
            color="content.title"
            pb={0}
            fontFamily="marketingPage">
            {headerText}
          </AlertDialogHeader>
          <AlertDialogBody
            fontSize="sm"
            whiteSpace={'pre-line'}
            pb={4}
            color="content.label"
            fontFamily="marketingPage">
            {bodyText}
          </AlertDialogBody>
          <AlertDialogFooter pt={0}>
            <Button
              buttonName="info-ok"
              borderRadius={8}
              w="100%"
              bg="icon.green"
              _hover={{
                bg: 'icon.green',
                opacity: 0.9,
              }}
              ref={cancelRef}
              onClick={onClose}
              fontSize="md"
              fontFamily="marketingPage">
              Got It
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </ChakraAlertDialog>
  );
};
